import AuthService from './AuthService';

class AnalyticsService {
    constructor() {
        const rawBaseUrl = process.env.REACT_APP_CHATBOT_API_URL || process.env.CHATBOT_API_URL || '';
        this.apiBaseUrl = rawBaseUrl.replace(/\/+$/, '');
    }

    async getAnalytics(params = {}) {
        const token = AuthService.getAccessToken();
        const loginAs = AuthService.getLoginAs();
        const query = new URLSearchParams();

        if (params.startDate) query.set('startDate', params.startDate);
        if (params.endDate) query.set('endDate', params.endDate);
        if (params.chatbotId) query.set('chatbotId', params.chatbotId);
        if (params.granularity) query.set('granularity', params.granularity);
        if (loginAs) query.set('loginAs', loginAs);

        const response = await fetch(`${this.apiBaseUrl}/private/analytics?${query.toString()}`, {
            headers: { Authorization: `Bearer ${token}` },
        });

        if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
        return response.json();
    }
}

const analyticsService = new AnalyticsService();
export default analyticsService;
